$(document).ready(function () {
//   Delete duplicate link on slider
  $('div.enap-img a:nth-child(2)').remove();
  setTimeout(() => { $('div.enap-slider-overlay').parent().remove(); }, 2000);
//   iFrames
  $('iframe[src*="youtube.com/embed/"]').attr('title','YouTube Video');
  $('iframe[src*="google.com/maps/embed"]').attr('title','Google Maps');
//   Product descriptions
  setTimeout(() => { 
             $('div.product-description-slider h3').attr('tabindex','0'); }, 2500);
});